module.exports = __webpack_public_path__ + "static/img/login-img.8e7d3d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login-img.png
// module id = 8h0x
// module chunks = 1